import axios from 'axios';

export default (token = null) => {
    delete axios.defaults.headers.common.authorization;
    if (token) {
        axios.defaults.headers.common.authorization = `Bearer ${token}`;
    }
    axios.defaults.headers.common['Content-Type'] = 'application/json';
    axios.defaults.headers.common.accept='application/json';
}


// WEBPACK FOOTER //
// ./src/utils/setAuthorizationHeader.js